export default __webpack_public_path__ + "a1d2da901cf0d8a61420a0aa2c59d286.svg";